export default function setOnboardingType(isOnShore: boolean) {
  return isOnShore ? 'BR' : 'NON BR';
}
